export const Image = ({url, width =100, height = 100, fitIn = true, ...props }) => {
    return (
        <img src={`${import.meta.env.VITE_URL_IMAGE}${fitIn ? '/fit-in' : ''}/${width}x${height}/${url}`} width={'100%'} {...props} />
    )
}